import { useQuery } from '@apollo/client'
import { getUserProfileFromGql } from '../graphql/userProfile'

export const useMainRouter = () => {
  const { loading, error, data } = useQuery(getUserProfileFromGql())

  return {
    loading,
    error,
    data,
  }
}
